// Single source of truth for app version
// Update this on every release — it drives the UI display and cache busting
const APP_VERSION = '2.9.380';
export default APP_VERSION;
